import { MarkExtension, MarkGroup, toggleMark, markInputRule, markPasteRule, extensionDecorator } from '@remirror/core';

var _dec, _class;
var ItalicExtension = (_dec = /*#__PURE__*/extensionDecorator({}), /*#__PURE__*/_dec(_class = class ItalicExtension extends MarkExtension {
  get name() {
    return 'italic';
  }

  createMarkSpec(extra) {
    return {
      attrs: extra.defaults(),
      group: MarkGroup.FontStyle,
      parseDOM: [{
        tag: 'i',
        getAttrs: extra.parse
      }, {
        tag: 'em',
        getAttrs: extra.parse
      }, {
        style: 'font-style=italic'
      }],
      toDOM: mark => ['em', extra.dom(mark), 0]
    };
  }

  createKeymap() {
    return {
      'Mod-i': toggleMark({
        type: this.type
      })
    };
  }

  createCommands() {
    return {
      /**
       * Toggle the italic formatting on the selected text.
       */
      toggleItalic: range => toggleMark({
        type: this.type,
        range
      })
    };
  }

  createInputRules() {
    return [markInputRule({
      regexp: /(?:^|[^*_])[*_]([^*_]+)[*_]$/,
      type: this.type
    })];
  }

  createPasteRules() {
    return [markPasteRule({
      regexp: /(?:^|[^*_])[*_]([^*_]+)[*_]/g,
      type: this.type
    })];
  }

}) || _class);

export { ItalicExtension };
